<div class="amc-body text-center">

  <button
    type="button"
    class="amc-close"
    aria-label="Close"
    *ngIf="!hideCloseButton"
    (click)="cancel()">
    <iconify-icon icon="mdi:close" width="18"></iconify-icon>
  </button>

  <iconify-icon
    *ngIf="!hideIcon"
    class="amc-icon"
    [ngClass]="'amc-icon--' + resolvedIconAnimation"
    [icon]="resolvedIcon"
    [style.color]="resolvedColor"
    width="64">
  </iconify-icon>

  <h4 class="amc-title" *ngIf="title" [style.color]="resolvedTitleColor">{{ title }}</h4>
  <div class="amc-message" [class.amc-message--no-buttons]="buttonCount === 0" [style.color]="resolvedMessageColor" [innerHTML]="message"></div>

  <div class="amc-buttons-wrap" *ngIf="buttonCount > 0">
    <div class="amc-buttons" [style.--amc-btn-count]="buttonCount" [ngSwitch]="mode">

      <ng-container *ngSwitchCase="'ok'">
        <button type="button" class="btn amc-btn-primary" [style.--amc-confirm-color]="resolvedConfirmColor" (click)="confirm()">
          {{ okText }}
        </button>
      </ng-container>

      <ng-container *ngSwitchCase="'yesno'">
        <button type="button" class="btn amc-btn-secondary" (click)="cancel()">
          {{ cancelText || 'Go Back' }}
        </button>
        <button type="button" class="btn amc-btn-primary" [style.--amc-confirm-color]="resolvedConfirmColor" (click)="confirm()">
          {{ confirmText || 'Yes' }}
        </button>
      </ng-container>

      <ng-container *ngSwitchCase="'yesnocancel'">
        <button type="button" class="btn amc-btn-ghost" (click)="cancel()">
          {{ cancelText || 'Cancel' }}
        </button>
        <button type="button" class="btn amc-btn-muted" (click)="extra()">
          {{ extraText || 'No' }}
        </button>
        <button type="button" class="btn amc-btn-primary" [style.--amc-confirm-color]="resolvedConfirmColor" (click)="confirm()">
          {{ confirmText || 'Yes' }}
        </button>
      </ng-container>

      <ng-container *ngSwitchCase="'custom'">
        <button
          type="button"
          class="btn"
          [ngClass]="btn.cssClass || 'amc-btn-ghost'"
          *ngFor="let btn of buttons"
          (click)="customClick(btn)">
          <iconify-icon *ngIf="btn.icon" [icon]="btn.icon" width="16" class="amc-btn-icon"></iconify-icon>
          {{ btn.text }}
        </button>
      </ng-container>

    </div>
  </div>
</div>